<template>
  <v-container class="h-100 container-db-tsa">
    <!-- btn search -->
    <v-row align="center" justify="center" class="mt-3">
      <v-col  cols="12" lg="3" md="3" sm="12" class="d-flex">
        <div class="text-from">FROM</div>
        <v-menu
          v-model="isOpenCalendar1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          z-index="12"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="StartDateformatted"
              placeholder="ระบุวัน/เดือน/ปี"
              class="date-input"
              color="green lighten-1"
              readonly dense outlined
              hide-details
              v-bind="attrs" v-on="on"
              append-icon="mdi-calendar"
              @click:append="isOpenCalendar1 = true"/>
          </template>
          <v-date-picker
            color="green lighten-1"
            header-color="green lighten-1"
            locale="th"
            v-model="StartDate"
            :max="today"
            @input="(e)=>{isOpenCalendar1 = false;}"/>
        </v-menu>
      </v-col>
      <!-- EndDate -->
      <v-col  cols="12" lg="3" md="3" sm="12" class="d-flex">
        <div class="text-to">TO</div>
        <v-menu
          v-model="isOpenCalendar2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          z-index="12"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="EndDateformatted"
              class="date-input"
              placeholder="ระบุวัน/เดือน/ปี"
              color="green lighten-1"
              readonly dense outlined
              hide-details
              v-bind="attrs" v-on="on"
              append-icon="mdi-calendar"
              @click:append="isOpenCalendar2 = true"
            />
          </template>
          <v-date-picker
            color="green lighten-1"
            header-color="green lighten-1"
            locale="th"
            :v-if="StartDate > EndDate ? EndDate='' : EndDate "
            :min="StartDate"
            :max="today"
            v-model="EndDate"
            @input="(e)=>{isOpenCalendar2 = false;}"/>
        </v-menu>
      </v-col>
      <!-- search -->
      <v-col cols="12" lg="1" md="1" sm="12" class="d-flex justify-content-center">
        <v-btn color="#6CB549" rounded dark @click="search()">
          <v-icon color="white" dark size="18" class="mr-1">mdi-magnify</v-icon> ค้นหา
        </v-btn>
      </v-col>

      <!-- <v-col  cols="12" lg="2" md="2" sm="2" xs="12" dir="rtl" style="margin-top: -8px;">
        <v-btn rounded color="#6CB549" height="" width="13vw" dark @click="Export()">Export
          <v-icon color="white" style="padding-left:11px" class="mr-3"> mdi-export</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>

    <!-- 4 card -->
    <div class="margin-card">
      <v-row align="center" align-content="center" style="justify-content: space-evenly !important;">
        <!-- <v-col class="col-6 col-md-3">
          <card-show class="card-container">
            <v-row align="center" align-content="center" justify="center">
              <v-col cols="4" align="center" class="justify-center d-flex"><v-icon class="icon-color-1" color="#CE8300">mdi-file-clock</v-icon></v-col>
              <v-col cols="8" align="center" class="text-card">
                <div class="text-sub">{{totalTransaction}} / {{packageTransaction}}</div>
                <div class="text-sub" style="color: #CE8300 !important">จำนวนการใช้บริการ/เดือน</div>
              </v-col>
            </v-row>
          </card-show>
        </v-col> -->
        <v-col class="col-6 col-md-3">
          <card-show class="card-container">
            <v-row align="center" align-content="center" justify="center">
              <v-col cols="4" align="center" class="justify-center d-flex"><v-icon class="icon-color-1" color="#0C6EC1">mdi-file-clock</v-icon></v-col>
              <v-col cols="8" align="center" class="text-card">
                <div class="text-sub">{{totalTSA}}</div>
                <div class="text-sub" style="color: #0C6EC1 !important">จำนวน TSA ทั้งหมด</div>
             </v-col>
            </v-row>
          </card-show>
        </v-col>
        <v-col class="col-6 col-md-3">
          <card-show class="card-container">
            <v-row align="center" align-content="center" justify="center">
              <v-col cols="4" align="center" class="justify-center d-flex"><v-icon class="icon-color-1" color="#39C036">mdi-file-clock</v-icon></v-col>
              <v-col cols="8" align="center" class="text-card">
                <div class="text-sub">{{totalTSASuccesss}}</div>
                <div class="text-sub" style="color: #39C036 !important" >จำนวน TSA Success</div>
             </v-col>
            </v-row>
          </card-show>
        </v-col>
        <v-col class="col-6 col-md-3">
          <card-show class="card-container">
            <v-row align="center" align-content="center" justify="center">
              <v-col cols="4" align="center" class="justify-center d-flex"><v-icon class="icon-color-1" color="#FF4D4D">mdi-file-clock</v-icon></v-col>
              <v-col cols="8" align="center" class="text-card">
                <div class="text-sub">{{totalTSAFail}}</div>
                <div class="text-sub" style="color: #FF4D4D !important" >จำนวน TSA Fail</div>
             </v-col>
            </v-row>
          </card-show>
        </v-col>
      </v-row>
    </div>

    <!-- Graph -->
    <v-row  class="margin-card">
      <!-- <v-carousel height="350" class="pt-2" hide-delimiter-background style="border-radius:4% !important"> -->
        <!-- <v-carousel-item v-for="(color) in colorsCarousel" :key="color"> -->
          <v-sheet color="green" height="100%" width="100%">
            <v-row class="fill-height" align="center" justify="center">
              <v-col class="padding-chart">
                <card-show class="card-chart">
                  <v-row class="fill-height" align="center" justify="center">
                    <v-col class="fill-height" align="center" justify="center">
                      <LineChartTSA/>
                    </v-col>
                  </v-row>
                </card-show>
              </v-col>
            </v-row>
          </v-sheet>
        <!-- </v-carousel-item> -->
      <!-- </v-carousel> -->
    </v-row>
  </v-container>
</template>

<script>
import { convertToDateFormat } from '@/utility/utility'
import { dateFormat } from '@/utility/utility'
import LineChartTSA from './component/chart/LineChartTSA.vue'
import CardShow from './component/card/CardShow.vue'
import { mapGetters } from 'vuex'
import { EventBus } from '@/EventBus'
export default {
  components: {
    CardShow,
    LineChartTSA
  },
  data: () => ({
    searchDate: '',
    today: convertToDateFormat(new Date()),
    StartDate: convertToDateFormat(new Date()),
    EndDate: convertToDateFormat(new Date()),
    isOpenCalendar1: false,
    isOpenCalendar2: false,
    totalTransaction: 0,
    packageTransaction: 300,
    totalTSA: 0,
    totalTSASuccesss: 0,
    totalTSAFail: 0,
    colorsCarousel: [
      // 'primary',
      'green',
      // 'yellow darken-2'
    ],
  }),
  computed: {
    ...mapGetters(['dataSummaryLog']),
    StartDateformatted () {
      return this.formatDate(this.StartDate)
    },
    EndDateformatted () {
      return this.formatDate(this.EndDate)
    }
  },
  mounted () {
    this.getSummaryLog()
  },
  beforeDestroy () {
  },
  methods: {
    async getSummaryLog () {
      const dataSent = {
        startDate: this.StartDate,
        endDate: this.EndDate,
        clientId: '',
        today: this.StartDate === this.EndDate
      }
      await this.$store.dispatch('getSummaryLog', dataSent)
      if (this.dataSummaryLog.responseCode === 200) {
        EventBus.$emit('dashboradDataLineCusGroup', this.dataSummaryLog.sfg)
        this.packageTransaction = 300
        this.totalTSASuccesss = this.dataSummaryLog.c_success
        this.totalTSAFail = this.dataSummaryLog.c_reject + this.dataSummaryLog.c_error
        this.totalTSA = this.totalTSASuccesss + this.totalTSAFail
        this.totalTransaction = this.dataSummaryLog.c_usagePerMonth
      } else {
        if (localStorage.getItem("active") === 'true') {
          this.$swal({
            title: '<span style="font-family: prompt; font-size: large; font-weight: 500;">เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</span>',
            icon: 'error',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push({ path: '/login' })
        } else {
          this.$router.push({ path: '/login' })
        }
      }
    },
    search () {
      this.getSummaryLog()
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    // setDate () {
    //   var date = new Date(); var y = date.getFullYear(); var m = date.getMonth()
    //   var firstDay = new Date(y, m, 2)
    //   const [month, year] = convertToDateMonth(firstDay).split('/')
    //   this.searchDate = year + '-' + month
    // }
    setDate () {
      var date = new Date()
      var y = date.getFullYear()
      // var m = date.getMonth()
      var firstDay = new Date(y, 0, 2)
      // this.EndDate = dateFormat(new Date())
      this.EndDate = y + '-12-31'
      this.StartDate = dateFormat(firstDay)
    },
  }
}
</script>

<style scoped>
.margin-card {
  margin: 3rem!important;
}
.card-chart {
  border-radius: 5px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  justify-content: center;
  flex-direction: column;
}
.text-sub {
  /* margin-top: 21px; */
  font-size: 16px;
  text-align: left;
  /* margin-bottom: 10%; */
}
.icon-color-1 {
  /* margin-left: 5%; */
  font-size: 60px;
  /* color:#6CB549 !important; */
}
.btn-search {
  border-radius: 2rem !important;
}
.card-container {
  display: flex;
  height: 8rem;
  /* margin-left: 32px; */
  padding-left: 0px;
  border-radius: 8px !important;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  justify-content: center;
  /* align-items: center; */
  flex-direction: column;
}

.container-db-tsa {
  width: 100% !important;
  overflow: auto;
  max-width: 100%;
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background: url("../../assets/bg-home2.jpg") no-repeat; */
  background-size: cover;
  background-blend-mode: soft-light;
  /* padding-bottom: 0px; */
  padding: 2rem;
  padding-top: 100px;
}
.padding-chart {
  padding: 48px !important;
}
@media screen and (max-width: 1210px) {
  .icon-color-1 {
    /* margin-left: 5%; */
    font-size: 40px;
    /* color:#6CB549 !important; */
  }
}
@media screen and (max-width: 959px) {
  .margin-card {
    margin: 0 !important;
    margin-top: 3rem !important;
  }
  .text-sub {
    font-size: 12px;
    margin-left: 5px;
  }
  .text-card {
    padding-left: 0px;
    padding-right: 15px;
  }
  .card-container {
    display: flex;
    height: 8rem;
    width: 100%;
    padding-left: 10%;
    margin-left: 0px;
    border-radius: 8px !important;
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    justify-content: center;
    /* align-items: center; */
    flex-direction: column;
  }

  .icon-color-1 {
    /* margin-left: 5%; */
    font-size: 30px;
    /* color:#6CB549 !important; */
  }
  .container-db-tsa {
    width: 100% !important;
    overflow: auto;
    max-width: 100%;
    height: 100%;
    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    /* background: url("../../assets/bg-home2.jpg") no-repeat; */
    background-size: cover;
    background-blend-mode: soft-light;
    /* padding-bottom: 60px; */
    padding-top: 80px;
  }
  .padding-chart {
    padding: 0px !important;
  }
}
.date-input{
  border-radius: 50px;
  font-size: small;
}
.text-from {
  align-self: center;
  margin-right: 20px;
  color: #626262;
  font-weight: 500;
}
.text-to {
  align-self: center;
  margin-right: 40px;
  color: #626262;
  font-weight: 500;
}
</style>